var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"items":_vm.monthList},model:{value:(_vm.month),callback:function ($$v) {_vm.month=$$v},expression:"month"}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }